// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2E-op","title":"Info_title__2g4ua","links":"Info_links__KBqLz","link":"Info_link__2s5b5","logo":"Info_logo__1VnLo"};